/**
 * @description Subscriber package keys from Smart Tag paramsVO.USER.userStatus pattern key|value
 */
export enum SubscriberPackageKey {
	/**
	 * @description Anonymous user
	 * @type {SubscriberPackageKey.ANON}
	 */
	ANON = 'anon',
	/**
	 * @description Ex-Subscriber Package
	 * @type {SubscriberPackageKey.ESB}
	 */
	ESB = 'esb',
	/**
	 * @description Paid Subscriber Package
	 * @type {SubscriberPackageKey.SB}
	 */
	SB = 'sb',
	/**
	 * @description Suspended Subscriber Package
	 * @type {SubscriberPackageKey.SSB}
	 */
	SSB = 'ssb',
	/**
	 * @description Trial Subscriber Package
	 * @type {SubscriberPackageKey.TSB}
	 */
	TSB = 'tsb',
	/**
	 * @description MVPD Authenticated user
	 * @type {SubscriberPackageKey.TVE}
	 */
	TVE = 'tve'
}